var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.666 7.33337V11L13.4993 12.8334",
    stroke: "#868686",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2.71578 10.0073C2.6738 10.4194 2.97383 10.7874 3.38591 10.8294C3.79799 10.8714 4.16608 10.5714 4.20805 10.1593L2.71578 10.0073ZM4.62472 13.4926C4.4826 13.1036 4.05199 12.9034 3.66292 13.0455C3.27385 13.1876 3.07366 13.6182 3.21578 14.0073L4.62472 13.4926ZM2.71191 18.3333C2.71191 18.7475 3.0477 19.0833 3.46191 19.0833C3.87613 19.0833 4.21191 18.7475 4.21191 18.3333H2.71191ZM3.46191 13.75V13C3.0477 13 2.71191 13.3358 2.71191 13.75H3.46191ZM8.04525 14.5C8.45946 14.5 8.79525 14.1642 8.79525 13.75C8.79525 13.3358 8.45946 13 8.04525 13V14.5ZM4.20805 10.1593C4.59467 6.36383 7.76893 3.46338 11.5838 3.41981L11.5667 1.91991C6.98883 1.97219 3.17971 5.45273 2.71578 10.0073L4.20805 10.1593ZM11.5838 3.41981C15.3986 3.37624 18.6383 6.20342 19.1115 9.98906L20.5999 9.80301C20.0321 5.26024 16.1445 1.86762 11.5667 1.91991L11.5838 3.41981ZM19.1115 9.98906C19.5847 13.7747 17.1406 17.3124 13.4325 18.2092L13.7851 19.6671C18.2349 18.591 21.1678 14.3458 20.5999 9.80301L19.1115 9.98906ZM13.4325 18.2092C9.72426 19.106 5.9337 17.0761 4.62472 13.4926L3.21578 14.0073C4.78656 18.3075 9.33522 20.7433 13.7851 19.6671L13.4325 18.2092ZM4.21191 18.3333V13.75H2.71191V18.3333H4.21191ZM3.46191 14.5H8.04525V13H3.46191V14.5Z",
    fill: "#868686"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.fff6f6131b14d1b1c835a86e1f954f03.svg";
export { ForwardRef as ReactComponent };